// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
import React from 'react'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
import { Textfit } from 'react-textfit'
import { StaticQuery, graphql } from 'gatsby'

import { GatsbyImage, getImage } from 'gatsby-plugin-image'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
import TableOfContents from '../table-of-contents/homepage-toc'
import '../table-of-contents/style.less'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions
// const { Fragment } = React

// ----------------------------------------------------------------------------
// ---------------------------------------------------------------------- Query
// ----------------------------------------------------------------------------
export const query = graphql`
  query {
    img: file(relativePath: { eq: "front.jpg" }) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: TRACED_SVG
          formats: [AUTO, WEBP, AVIF]
        )
      }
    }
  }
`

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/** [description] */
const CoverPage = () => (
  <StaticQuery
    query={query}
    render={(data) => (
      <div className="container">
        <div className="cover as-paragraph">
          <GatsbyImage image={getImage(data.img)} />
        </div>
        <p>
          Today, information about Auroville is abundant. Many people try to
          make meaning out of Auroville – about its conception, to what
          direction should we grow towards, and, what are we doing here?
        </p>
        <p>
          But what was Mother’s original Dream and what was her Vision for
          Auroville back then? We now have more materials on hand to go back in
          time and retrace her steps. This book is a new compilation of texts
          and quotes that Mother had left for us. It is our choice to
          contemplate on this, to reflect what we have made out of Auroville,
          and for what are we here today.
        </p>
        <p>
          Don't forget we also have to Dream this New World into Being. Don't
          forget who we are and where we come from and that we are here to do
          something together.
        </p>
        <h2>Table of Contents</h2>
        <TableOfContents />
      </div>
    )}
  />
)

// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------
export default CoverPage
